/* eslint-disable max-lines */
import MidnightHero from '../img/theme/heroes/Midnight.jpg'
import HawaiiHero from '../img/theme/heroes/Hawaii.jpg'
import ArizonaHero from '../img/theme/heroes/Arizona.jpg'
import LushHero from '../img/theme/heroes/Lush.jpg'
import PirateHero from '../img/theme/heroes/Pirate.jpg'
import CorporateHero from '../img/theme/heroes/Corporation.jpg'
import StrategyHome from '../img/portfolio/strategy/home.png'
import StrategySettings from '../img/portfolio/strategy/app-settings.png'
import StrategyBoard from '../img/portfolio/strategy/board.png'
import StrategyItem from '../img/portfolio/strategy/file-name-strategy.png'
import StrategyForgot from '../img/portfolio/strategy/forgot-password.png'
import StrategyItemEdit from '../img/portfolio/strategy/item-edit-view.png'
import StrategyLogin from '../img/portfolio/strategy/login.png'
import StrategyMember from '../img/portfolio/strategy/member-info.png'
import StrategyProject from '../img/portfolio/strategy/project-page.png'
import StrategyPublicBoard from '../img/portfolio/strategy/public-board.png'
import StrategyRegister from '../img/portfolio/strategy/register.png'
import FreelanceHome from '../img/portfolio/freelance/home.jpg'
import FreelanceProduct from '../img/portfolio/freelance/product.jpg'
import FreelanceTestimonials from '../img/portfolio/freelance/testimonials.jpg'
import FreelanceContact from '../img/portfolio/freelance/contact.jpg'
import IboatsHome from '../img/portfolio/iboats/home.jpg'
import IboatsAccount from '../img/portfolio/iboats/account-info.jpg'
import IboatsAd from '../img/portfolio/iboats/ad.jpg'
import IboatsSearch from '../img/portfolio/iboats/advanced-search.jpg'
import IboatsCheckout from '../img/portfolio/iboats/check-out.jpg'
import IboatsCreateBoat from '../img/portfolio/iboats/create-record.jpg'
import IboatsFeatured from '../img/portfolio/iboats/featured.jpg'
import IboatsOptions from '../img/portfolio/iboats/options.jpg'
import IboatsPromo from '../img/portfolio/iboats/promo.jpg'
import IboatsRecord from '../img/portfolio/iboats/record.jpg'
import IboatsResearch from '../img/portfolio/iboats/research.jpg'
import IboatsType from '../img/portfolio/iboats/type-listings.jpg'
import IboatsResearchType from '../img/portfolio/iboats/research-type-listing.jpg'
import PlusOneDash from '../img/portfolio/plueone/dashboard.png'
import PlusOneDate from '../img/portfolio/plueone/datepicker.png'
import PlusOneLogin from '../img/portfolio/plueone/login.png'
import PlusOneStyle from '../img/portfolio/plueone/styleguide.png'
import PlusOneTable from '../img/portfolio/plueone/table.png'
import PlusOneWorkFlow from '../img/portfolio/plueone/work-flow-1.png'
import AzdeqForm from '../img/portfolio/azdeq/form.png'
import AzdeqInfo from '../img/portfolio/azdeq/Info.png'
import AzdeqLog from '../img/portfolio/azdeq/log.png'
import AzdeqReg from '../img/portfolio/azdeq/register.png'
import AzdeqStart from '../img/portfolio/azdeq/start.png'
import AzdeqStepper from '../img/portfolio/azdeq/Stepper.png'
import ArizonaMountains from '../img/theme/viewport-backgrounds/Arizona-Mountains.jpg'
import ArizonaCathedralRock from '../img/theme/viewport-backgrounds/Arizona-Sedona-CathedralRock.jpg'
import ArizonaSedona from '../img/theme/viewport-backgrounds/Arizona-Sedona-Mountains.jpg'
import CorporateBuildings from '../img/theme/viewport-backgrounds/Corporate-Buildings.jpg'
import CorporateLaptop from '../img/theme/viewport-backgrounds/Corporate-Laptop.jpg'
import CorporateStrategies from '../img/theme/viewport-backgrounds/Corporate-Strategies.jpg'
import LushHike from '../img/theme/viewport-backgrounds/Lush-Hike.jpg'
import LushLeaves from '../img/theme/viewport-backgrounds/Lush-Leaves.jpg'
import LushVegetation from '../img/theme/viewport-backgrounds/Lush-Vegitation.jpg'
import PirateAffects from '../img/theme/viewport-backgrounds/Pirate-Affects.jpg'
import PirateSkull from '../img/theme/viewport-backgrounds/Pirate-Skull.jpg'
import PirateShips from '../img/theme/viewport-backgrounds/Pirate-Ships.jpg'
import MidnightForest from '../img/theme/viewport-backgrounds/Midnight-Forest.jpg'
import MidnightFullMoon from '../img/theme/viewport-backgrounds/Midnight-FullMoon.jpg'
import HawaiiSunset from '../img/theme/viewport-backgrounds/Hawaii-Sunset.jpg'
import HawaiiFlower from '../img/theme/viewport-backgrounds/Hawaii-Flower.jpg'
import ArizonaThemeSidebar from '../img/theme/sidebar-backgrounds/arizona-theme-sidebar.jpg'
import LushThemeSidebar from '../img/theme/sidebar-backgrounds/lush-theme-sidebar.jpg'
import HawaiiThemeSidebar from '../img/theme/sidebar-backgrounds/beach-theme-sidebar.jpg'
import PirateThemeSidebar from '../img/theme/sidebar-backgrounds/pirate-theme-sidebar.jpg'
import CorporateThemeSidebar from '../img/theme/sidebar-backgrounds/corporation-theme-sidebar.jpg'
import MidnightThemeSidebar from '../img/theme/sidebar-backgrounds/midnight-theme-sidebar.jpg'

import CompassCover from '../img/portfolio/compass/Compass-Cover.png'
import CompassFinancial from '../img/portfolio/compass/Compass-Financial.png'
import CompassFitness from '../img/portfolio/compass/Compass-Fitness.png'

export {
  CompassCover,
  CompassFinancial,
  CompassFitness,
  MidnightHero,
  HawaiiHero,
  ArizonaHero,
  LushHero,
  PirateHero,
  CorporateHero,
  FreelanceTestimonials,
  FreelanceContact,
  FreelanceHome,
  FreelanceProduct,
  IboatsHome,
  IboatsAccount,
  IboatsAd,
  IboatsPromo,
  IboatsType,
  IboatsSearch,
  IboatsFeatured,
  IboatsRecord,
  IboatsCheckout,
  IboatsResearch,
  IboatsCreateBoat,
  IboatsOptions,
  IboatsResearchType,
  AzdeqReg,
  AzdeqStepper,
  AzdeqLog,
  PlusOneWorkFlow,
  AzdeqStart,
  PlusOneTable,
  AzdeqInfo,
  PlusOneDate,
  AzdeqForm,
  PlusOneLogin,
  PlusOneStyle,
  PlusOneDash,
  ArizonaSedona,
  ArizonaMountains,
  ArizonaCathedralRock,
  CorporateStrategies,
  CorporateLaptop,
  CorporateBuildings,
  LushVegetation,
  LushLeaves,
  LushHike,
  PirateAffects,
  PirateShips,
  PirateSkull,
  MidnightFullMoon,
  MidnightForest,
  HawaiiFlower,
  ArizonaThemeSidebar,
  LushThemeSidebar,
  HawaiiThemeSidebar,
  PirateThemeSidebar,
  CorporateThemeSidebar,
  MidnightThemeSidebar,
  StrategyHome,
  StrategySettings,
  StrategyBoard,
  StrategyItem,
  StrategyForgot,
  StrategyItemEdit,
  StrategyLogin,
  StrategyMember,
  StrategyProject,
  StrategyPublicBoard,
  StrategyRegister,
}

export const themeHeroes = {
  Corporate: CorporateHero,
  Midnight: MidnightHero,
  Hawaii: HawaiiHero,
  Arizona: ArizonaHero,
  Pirate: PirateHero,
  Lush: LushHero,
}

export const heroes = [
  {id: 'Corporate', src: CorporateHero, label: 'Corporate Hero'},
  {id: 'Midnight', src: MidnightHero, label: 'Midnight Hero'},
  {id: 'Hawaii', src: HawaiiHero, label: 'Hawaii Hero'},
  {id: 'Arizona', src: ArizonaHero, label: 'Arizona Hero'},
  {id: 'Pirate', src: PirateHero, label: 'Pirate Hero'},
  {id: 'Lush', src: LushHero, label: 'Lush Hero'},
]

export const themePreviewBackgrounds = {
  Hawaii: HawaiiSunset,
  Midnight: MidnightFullMoon,
  Arizona: ArizonaMountains,
  Corporate: CorporateLaptop,
  Lush: LushVegetation,
  Pirate: PirateShips,
}

export const themeSidebarBackgrounds = [
  {id: 'Corporate', src: CorporateThemeSidebar, label: 'Corporate building'},
  {id: 'Midnight', src: MidnightThemeSidebar, label: 'Midnight Moon'},
  {id: 'Hawaii', src: HawaiiThemeSidebar, label: 'Beach Hammock'},
  {id: 'Arizona', src: ArizonaThemeSidebar, label: 'Arizona Home'},
  {id: 'Pirate', src: PirateThemeSidebar, label: 'Skull in woods'},
  {id: 'Lush', src: LushThemeSidebar, label: 'Vegetation'},
]
